package com.iregained.site.components.sections.home.styles

import com.varabyte.kobweb.compose.css.AnimationIterationCount
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.animation
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateX
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.AnimationPlayState
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.s


// 1. The Keyframes: Slide completely to the left
val MarqueeKeyframes = Keyframes {
    0.percent { Modifier.translateX(0.percent) }
    100.percent { Modifier.translateX((-100).percent) }
}

val MarqueeTrackStyle = CssStyle {
    base {
        Modifier.flexShrink(0) // Stops the tracks from squishing together
            .styleModifier {
                property("will-change", "transform")
                property("-webkit-transform", "translateZ(0)")
            }.animation(
                MarqueeKeyframes.toAnimation(
                    duration = 30.s,
                    timingFunction = AnimationTimingFunction.Linear,
                    iterationCount = AnimationIterationCount.Infinite,
                    playState = AnimationPlayState.Running // FIXED: Explicitly sets default state so browser doesn't guess
                )
            )
    }
}

val MarqueeContainerStyle = CssStyle {
    cssRule(":hover > *") {
        Modifier.styleModifier { property("animation-play-state", "paused !important") }
    }
}

// Added the missing grayscale-to-color transition
val PartnerLogoStyle = CssStyle {
    base {
        Modifier.transition(Transition.of("filter", 0.3.s))
            .styleModifier { property("filter", "grayscale(0%) opacity(80%)") }
    }
    hover {
        Modifier.styleModifier { property("filter", "grayscale(0%) opacity(100%)") }
    }
}